import { inject, Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { translationLoaders } from '@fitness-force/assets';
import { from, Observable, of } from 'rxjs';

import {
  CHUNK_LOAD_RECOVERY,
  createBrowserChunkLoadRecovery,
  isChunkLoadError,
} from './chunk-load-recovery';

@Injectable()
export class LazyTranslateLoader implements TranslateLoader {
  private readonly chunkRecovery =
    inject(CHUNK_LOAD_RECOVERY, { optional: true }) ??
    createBrowserChunkLoadRecovery();

  getTranslation(lang: string): Observable<TranslationObject> {
    const loader = translationLoaders[lang as keyof typeof translationLoaders];

    if (!loader) {
      return of({});
    }

    return from(
      loader()
        .then((translations) => {
          this.chunkRecovery.clearReloadMarker();
          return translations as TranslationObject;
        })
        .catch((error: unknown) => {
          if (isChunkLoadError(error) && !this.chunkRecovery.hasReloadMarker()) {
            this.chunkRecovery.setReloadMarker();
            this.chunkRecovery.reload();
          }

          return {} as TranslationObject;
        }),
    );
  }
}
